function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Q2BG"
}, /*#__PURE__*/React.createElement("g", {
  id: "Q2BG1",
  className: "st0"
}, /*#__PURE__*/React.createElement("g", {
  id: "HC",
  className: "st1"
}, /*#__PURE__*/React.createElement("path", {
  id: "HC1",
  className: "st2",
  d: "M449,202c0-9.4-7.6-17-17-17s-17,7.6-17,17"
}), /*#__PURE__*/React.createElement("path", {
  id: "HC2",
  className: "st2",
  d: "M463.8,202c0-17.6-14.2-31.8-31.8-31.8s-31.8,14.2-31.8,31.8"
}), /*#__PURE__*/React.createElement("path", {
  id: "HC3",
  className: "st2",
  d: "M478.6,202c0-25.7-20.9-46.6-46.6-46.6s-46.6,20.9-46.6,46.6"
}), /*#__PURE__*/React.createElement("path", {
  id: "HC4",
  className: "st2",
  d: "M493.4,202c0-33.9-27.5-61.4-61.4-61.4s-61.4,27.5-61.4,61.4"
}), /*#__PURE__*/React.createElement("path", {
  id: "HC5",
  className: "st2",
  d: "M508.2,202c0-42.1-34.1-76.2-76.2-76.2s-76.2,34.1-76.2,76.2"
}), /*#__PURE__*/React.createElement("path", {
  id: "HC6",
  className: "st2",
  d: "M523,202c0-50.3-40.7-91-91-91s-91,40.7-91,91"
})), /*#__PURE__*/React.createElement("g", {
  id: "HB",
  className: "st1"
}, /*#__PURE__*/React.createElement("path", {
  id: "HB1",
  className: "st3",
  d: "M260.1,202c0-5.2-4.2-9.5-9.5-9.5s-9.5,4.2-9.5,9.5"
}), /*#__PURE__*/React.createElement("path", {
  id: "HB2",
  className: "st3",
  d: "M273.8,202c0-12.8-10.4-23.2-23.2-23.2c-12.8,0-23.2,10.4-23.2,23.2"
}), /*#__PURE__*/React.createElement("path", {
  id: "HB3",
  className: "st3",
  d: "M287.6,202c0-20.4-16.5-36.9-36.9-36.9s-36.9,16.5-36.9,36.9"
}), /*#__PURE__*/React.createElement("path", {
  id: "HB4",
  className: "st3",
  d: "M301.3,202c0-28-22.7-50.7-50.7-50.7S199.9,174,199.9,202"
})), /*#__PURE__*/React.createElement("g", {
  id: "HA",
  className: "st1"
}, /*#__PURE__*/React.createElement("path", {
  id: "HA1",
  className: "st4",
  d: "M268.2,0.7c0,12.4,10.1,22.5,22.5,22.5s22.5-10.1,22.5-22.5"
}), /*#__PURE__*/React.createElement("path", {
  id: "HA2",
  className: "st4",
  d: "M248.6,0.7c0,23.3,18.8,42.1,42.1,42.1s42.1-18.8,42.1-42.1"
}), /*#__PURE__*/React.createElement("path", {
  id: "HA3",
  className: "st4",
  d: "M229,0.7c0,34.1,27.6,61.7,61.7,61.7s61.7-27.6,61.7-61.7"
}), /*#__PURE__*/React.createElement("path", {
  id: "HA4",
  className: "st4",
  d: "M209.4,0.7c0,44.9,36.4,81.3,81.3,81.3S372,45.6,372,0.7"
}), /*#__PURE__*/React.createElement("path", {
  id: "HA5",
  className: "st4",
  d: "M189.8,0.7c0,55.7,45.2,100.9,100.9,100.9S391.5,56.4,391.5,0.7"
}), /*#__PURE__*/React.createElement("path", {
  id: "HA6",
  className: "st4",
  d: "M170.2,0.7c0,66.5,53.9,120.5,120.5,120.5S411.1,67.2,411.1,0.7"
}))), /*#__PURE__*/React.createElement("g", {
  id: "Q2BG2"
}, /*#__PURE__*/React.createElement("g", {
  id: "BD"
}, /*#__PURE__*/React.createElement("path", {
  id: "BD1",
  className: "st2",
  d: "M385.3,201.3c0-20.7-16.8-37.5-37.5-37.5s-37.5,16.8-37.5,37.5"
}), /*#__PURE__*/React.createElement("path", {
  id: "BD2",
  className: "st2",
  d: "M412.5,201.3c0-35.7-29-64.7-64.7-64.7s-64.7,29-64.7,64.7"
}), /*#__PURE__*/React.createElement("path", {
  id: "BD3",
  className: "st2",
  d: "M439.7,201.3c0-50.7-41.1-91.9-91.9-91.9S256,150.6,256,201.3"
}), /*#__PURE__*/React.createElement("path", {
  id: "BD4",
  className: "st2",
  d: "M466.9,201.3c0-65.7-53.3-119.1-119.1-119.1s-119.1,53.3-119.1,119.1"
}), /*#__PURE__*/React.createElement("path", {
  id: "BD5",
  className: "st2",
  d: "M494.1,201.3c0-80.8-65.5-146.2-146.2-146.2s-146.2,65.5-146.2,146.2"
}), /*#__PURE__*/React.createElement("path", {
  id: "BD6",
  className: "st2",
  d: "M521.3,201.3c0-95.8-77.6-173.4-173.4-173.4s-173.4,77.6-173.4,173.4"
}), /*#__PURE__*/React.createElement("path", {
  id: "BD7",
  className: "st2",
  d: "M548.5,201.3c0-110.8-89.8-200.6-200.6-200.6S147.2,90.5,147.2,201.3"
}))));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Q2damage"
}, /*#__PURE__*/React.createElement("g", {
  id: "Q2D4"
}, /*#__PURE__*/React.createElement("path", {
  d: "M272.7,122.3c0-18.3-6.2-45.1-6.2-45.1v-0.1V70h-64.9v7.3h0.1v0.3c-0.7,3.1-6.1,27.6-6.1,44.7c0,0.7,0,1.4,0,2.1 c0,0.3,0,0.7,0,1c0,0.7,0,1.5,0,2.2h0.1c0.9,16.1,5.4,34.3,6,36.8v0.3h-0.1v7.3h64.9v-7.3c0,0,5.1-19.8,6-37.1h0.1 c0-0.7,0-1.5,0-2.2c0-0.3,0-0.7,0-1C272.7,123.7,272.7,123,272.7,122.3z"
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st5",
  d: "M202.2,77.3c0,0-6.2,26.7-6.2,45.1s6.2,42.4,6.2,42.4"
}), /*#__PURE__*/React.createElement("path", {
  className: "st5",
  d: "M267.1,77.3c0,0,6.2,26.7,6.2,45.1s-6.2,42.4-6.2,42.4"
}), /*#__PURE__*/React.createElement("path", {
  className: "st3",
  d: "M258.2,77.3c0,0,3.4,26.7,3.4,45.1s-3.4,42.4-3.4,42.4"
}), /*#__PURE__*/React.createElement("path", {
  className: "st3",
  d: "M248.2,77.3c0,0,1.5,26.7,1.5,45.1s-1.5,42.4-1.5,42.4"
}), /*#__PURE__*/React.createElement("path", {
  className: "st3",
  d: "M211.1,77.3c0,0-3.4,26.7-3.4,45.1s3.4,42.4,3.4,42.4"
}), /*#__PURE__*/React.createElement("path", {
  className: "st3",
  d: "M221.1,77.3c0,0-1.5,26.7-1.5,45.1s1.5,42.4,1.5,42.4"
})), /*#__PURE__*/React.createElement("rect", {
  x: 202.2,
  y: 70,
  className: "st6",
  width: 64.9,
  height: 7.3
}), /*#__PURE__*/React.createElement("rect", {
  x: 202.2,
  y: 164.8,
  className: "st6",
  width: 64.9,
  height: 7.3
}), /*#__PURE__*/React.createElement("rect", {
  x: 228.2,
  y: 77.3,
  className: "st7",
  width: 12.9,
  height: 87.5
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st7",
  d: "M272.8,115.7h-76.3c-0.3,3.3-0.5,6.6-0.5,9.8c0,0.7,0,1.5,0,2.2h77.2c0-0.7,0-1.5,0-2.2 C273.3,122.3,273.1,118.9,272.8,115.7z"
})), /*#__PURE__*/React.createElement("circle", {
  className: "st7",
  cx: 234.7,
  cy: 121.7,
  r: 2.5
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
  className: "st8",
  cx: 231.4,
  cy: 84,
  r: 1.3
}), /*#__PURE__*/React.createElement("circle", {
  className: "st8",
  cx: 231.4,
  cy: 91.6,
  r: 1.3
}), /*#__PURE__*/React.createElement("circle", {
  className: "st8",
  cx: 231.4,
  cy: 99.2,
  r: 1.3
}), /*#__PURE__*/React.createElement("circle", {
  className: "st8",
  cx: 231.4,
  cy: 106.8,
  r: 1.3
}), /*#__PURE__*/React.createElement("circle", {
  className: "st8",
  cx: 237.7,
  cy: 84,
  r: 1.3
}), /*#__PURE__*/React.createElement("circle", {
  className: "st8",
  cx: 237.7,
  cy: 91.6,
  r: 1.3
}), /*#__PURE__*/React.createElement("circle", {
  className: "st8",
  cx: 237.7,
  cy: 99.2,
  r: 1.3
}), /*#__PURE__*/React.createElement("circle", {
  className: "st8",
  cx: 237.7,
  cy: 106.8,
  r: 1.3
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
  className: "st8",
  cx: 231.4,
  cy: 134.2,
  r: 1.3
}), /*#__PURE__*/React.createElement("circle", {
  className: "st8",
  cx: 231.4,
  cy: 141.8,
  r: 1.3
}), /*#__PURE__*/React.createElement("circle", {
  className: "st8",
  cx: 231.4,
  cy: 149.4,
  r: 1.3
}), /*#__PURE__*/React.createElement("circle", {
  className: "st8",
  cx: 231.4,
  cy: 157,
  r: 1.3
}), /*#__PURE__*/React.createElement("circle", {
  className: "st8",
  cx: 237.7,
  cy: 134.2,
  r: 1.3
}), /*#__PURE__*/React.createElement("circle", {
  className: "st8",
  cx: 237.7,
  cy: 141.8,
  r: 1.3
}), /*#__PURE__*/React.createElement("circle", {
  className: "st8",
  cx: 237.7,
  cy: 149.4,
  r: 1.3
}), /*#__PURE__*/React.createElement("circle", {
  className: "st8",
  cx: 237.7,
  cy: 157,
  r: 1.3
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
  className: "st8",
  cx: 268.9,
  cy: 118.5,
  r: 1.3
}), /*#__PURE__*/React.createElement("circle", {
  className: "st8",
  cx: 261.3,
  cy: 118.5,
  r: 1.3
}), /*#__PURE__*/React.createElement("circle", {
  className: "st8",
  cx: 253.7,
  cy: 118.5,
  r: 1.3
}), /*#__PURE__*/React.createElement("circle", {
  className: "st8",
  cx: 246.1,
  cy: 118.5,
  r: 1.3
}), /*#__PURE__*/React.createElement("circle", {
  className: "st8",
  cx: 268.9,
  cy: 124.8,
  r: 1.3
}), /*#__PURE__*/React.createElement("circle", {
  className: "st8",
  cx: 261.3,
  cy: 124.8,
  r: 1.3
}), /*#__PURE__*/React.createElement("circle", {
  className: "st8",
  cx: 253.7,
  cy: 124.8,
  r: 1.3
}), /*#__PURE__*/React.createElement("circle", {
  className: "st8",
  cx: 246.1,
  cy: 124.8,
  r: 1.3
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
  className: "st8",
  cx: 224.1,
  cy: 118.5,
  r: 1.3
}), /*#__PURE__*/React.createElement("circle", {
  className: "st8",
  cx: 216.5,
  cy: 118.5,
  r: 1.3
}), /*#__PURE__*/React.createElement("circle", {
  className: "st8",
  cx: 208.9,
  cy: 118.5,
  r: 1.3
}), /*#__PURE__*/React.createElement("circle", {
  className: "st8",
  cx: 201.3,
  cy: 118.5,
  r: 1.3
}), /*#__PURE__*/React.createElement("circle", {
  className: "st8",
  cx: 224.1,
  cy: 124.8,
  r: 1.3
}), /*#__PURE__*/React.createElement("circle", {
  className: "st8",
  cx: 216.5,
  cy: 124.8,
  r: 1.3
}), /*#__PURE__*/React.createElement("circle", {
  className: "st8",
  cx: 208.9,
  cy: 124.8,
  r: 1.3
}), /*#__PURE__*/React.createElement("circle", {
  className: "st8",
  cx: 201.3,
  cy: 124.8,
  r: 1.3
})))), /*#__PURE__*/React.createElement("g", {
  id: "Q2D3"
}, /*#__PURE__*/React.createElement("path", {
  d: "M500.3,122.3c0-18.3-6.2-45.1-6.2-45.1v-0.1V70h-64.9v7.3h0.1v0.3c-0.7,3.1-6.1,27.6-6.1,44.7c0,0.7,0,1.4,0,2.1 c0,0.3,0,0.7,0,1c0,0.7,0,1.5,0,2.2h0.1c0.9,16.1,5.4,34.3,6,36.8v0.3h-0.1v7.3h64.9v-7.3c0,0,5.1-19.8,6-37.1h0.1 c0-0.7,0-1.5,0-2.2c0-0.3,0-0.7,0-1C500.3,123.7,500.3,123,500.3,122.3z"
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st5",
  d: "M429.8,77.3c0,0-6.2,26.7-6.2,45.1s6.2,42.4,6.2,42.4"
}), /*#__PURE__*/React.createElement("path", {
  className: "st5",
  d: "M494.7,77.3c0,0,6.2,26.7,6.2,45.1s-6.2,42.4-6.2,42.4"
}), /*#__PURE__*/React.createElement("path", {
  className: "st3",
  d: "M485.8,77.3c0,0,3.4,26.7,3.4,45.1s-3.4,42.4-3.4,42.4"
}), /*#__PURE__*/React.createElement("path", {
  className: "st3",
  d: "M475.8,77.3c0,0,1.5,26.7,1.5,45.1s-1.5,42.4-1.5,42.4"
}), /*#__PURE__*/React.createElement("path", {
  className: "st3",
  d: "M438.7,77.3c0,0-3.4,26.7-3.4,45.1s3.4,42.4,3.4,42.4"
}), /*#__PURE__*/React.createElement("path", {
  className: "st3",
  d: "M448.7,77.3c0,0-1.5,26.7-1.5,45.1s1.5,42.4,1.5,42.4"
})), /*#__PURE__*/React.createElement("rect", {
  x: 455.8,
  y: 77.3,
  className: "st7",
  width: 12.9,
  height: 87.5
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st7",
  d: "M500.4,115.7h-76.3c-0.3,3.3-0.5,6.6-0.5,9.8c0,0.7,0,1.5,0,2.2h77.2c0-0.7,0-1.5,0-2.2 C500.9,122.3,500.7,118.9,500.4,115.7z"
})), /*#__PURE__*/React.createElement("circle", {
  className: "st7",
  cx: 462.2,
  cy: 121.7,
  r: 2.5
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
  className: "st8",
  cx: 459,
  cy: 84,
  r: 1.3
}), /*#__PURE__*/React.createElement("circle", {
  className: "st8",
  cx: 459,
  cy: 91.6,
  r: 1.3
}), /*#__PURE__*/React.createElement("circle", {
  className: "st8",
  cx: 459,
  cy: 99.2,
  r: 1.3
}), /*#__PURE__*/React.createElement("circle", {
  className: "st8",
  cx: 459,
  cy: 106.8,
  r: 1.3
}), /*#__PURE__*/React.createElement("circle", {
  className: "st8",
  cx: 465.3,
  cy: 84,
  r: 1.3
}), /*#__PURE__*/React.createElement("circle", {
  className: "st8",
  cx: 465.3,
  cy: 91.6,
  r: 1.3
}), /*#__PURE__*/React.createElement("circle", {
  className: "st8",
  cx: 465.3,
  cy: 99.2,
  r: 1.3
}), /*#__PURE__*/React.createElement("circle", {
  className: "st8",
  cx: 465.3,
  cy: 106.8,
  r: 1.3
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
  className: "st8",
  cx: 459,
  cy: 134.2,
  r: 1.3
}), /*#__PURE__*/React.createElement("circle", {
  className: "st8",
  cx: 459,
  cy: 141.8,
  r: 1.3
}), /*#__PURE__*/React.createElement("circle", {
  className: "st8",
  cx: 459,
  cy: 149.4,
  r: 1.3
}), /*#__PURE__*/React.createElement("circle", {
  className: "st8",
  cx: 459,
  cy: 157,
  r: 1.3
}), /*#__PURE__*/React.createElement("circle", {
  className: "st8",
  cx: 465.3,
  cy: 134.2,
  r: 1.3
}), /*#__PURE__*/React.createElement("circle", {
  className: "st8",
  cx: 465.3,
  cy: 141.8,
  r: 1.3
}), /*#__PURE__*/React.createElement("circle", {
  className: "st8",
  cx: 465.3,
  cy: 149.4,
  r: 1.3
}), /*#__PURE__*/React.createElement("circle", {
  className: "st8",
  cx: 465.3,
  cy: 157,
  r: 1.3
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
  className: "st8",
  cx: 496.5,
  cy: 118.5,
  r: 1.3
}), /*#__PURE__*/React.createElement("circle", {
  className: "st8",
  cx: 488.9,
  cy: 118.5,
  r: 1.3
}), /*#__PURE__*/React.createElement("circle", {
  className: "st8",
  cx: 481.3,
  cy: 118.5,
  r: 1.3
}), /*#__PURE__*/React.createElement("circle", {
  className: "st8",
  cx: 473.7,
  cy: 118.5,
  r: 1.3
}), /*#__PURE__*/React.createElement("circle", {
  className: "st8",
  cx: 496.5,
  cy: 124.8,
  r: 1.3
}), /*#__PURE__*/React.createElement("circle", {
  className: "st8",
  cx: 488.9,
  cy: 124.8,
  r: 1.3
}), /*#__PURE__*/React.createElement("circle", {
  className: "st8",
  cx: 481.3,
  cy: 124.8,
  r: 1.3
}), /*#__PURE__*/React.createElement("circle", {
  className: "st8",
  cx: 473.7,
  cy: 124.8,
  r: 1.3
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
  className: "st8",
  cx: 451.7,
  cy: 118.5,
  r: 1.3
}), /*#__PURE__*/React.createElement("circle", {
  className: "st8",
  cx: 444.1,
  cy: 118.5,
  r: 1.3
}), /*#__PURE__*/React.createElement("circle", {
  className: "st8",
  cx: 436.5,
  cy: 118.5,
  r: 1.3
}), /*#__PURE__*/React.createElement("circle", {
  className: "st8",
  cx: 428.9,
  cy: 118.5,
  r: 1.3
}), /*#__PURE__*/React.createElement("circle", {
  className: "st8",
  cx: 451.7,
  cy: 124.8,
  r: 1.3
}), /*#__PURE__*/React.createElement("circle", {
  className: "st8",
  cx: 444.1,
  cy: 124.8,
  r: 1.3
}), /*#__PURE__*/React.createElement("circle", {
  className: "st8",
  cx: 436.5,
  cy: 124.8,
  r: 1.3
}), /*#__PURE__*/React.createElement("circle", {
  className: "st8",
  cx: 428.9,
  cy: 124.8,
  r: 1.3
})), /*#__PURE__*/React.createElement("rect", {
  x: 429.8,
  y: 70,
  className: "st6",
  width: 64.9,
  height: 7.3
}), /*#__PURE__*/React.createElement("rect", {
  x: 429.8,
  y: 164.8,
  className: "st6",
  width: 64.9,
  height: 7.3
}))), /*#__PURE__*/React.createElement("g", {
  id: "Q2D2"
}, /*#__PURE__*/React.createElement("path", {
  d: "M311.7,134.9c0-13.7-4.6-33.7-4.6-33.7v-0.1v-5.4h-48.5v5.4h0v0.2c-0.5,2.3-4.6,20.6-4.6,33.5c0,0.5,0,1,0,1.6 c0,0.3,0,0.5,0,0.8c0,0.6,0,1.1,0,1.6h0.1c0.7,12.1,4,25.7,4.5,27.5v0.2h0v5.4H307v-5.4c0,0,3.8-14.8,4.5-27.8h0.1 c0-0.5,0-1.1,0-1.6c0-0.3,0-0.5,0-0.8C311.6,135.9,311.7,135.4,311.7,134.9z"
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st5",
  d: "M259,101.2c0,0-4.6,20-4.6,33.7s4.6,31.7,4.6,31.7"
}), /*#__PURE__*/React.createElement("path", {
  className: "st5",
  d: "M307.5,101.2c0,0,4.6,20,4.6,33.7s-4.6,31.7-4.6,31.7"
}), /*#__PURE__*/React.createElement("path", {
  className: "st3",
  d: "M300.9,101.2c0,0,2.5,20,2.5,33.7s-2.5,31.7-2.5,31.7"
}), /*#__PURE__*/React.createElement("path", {
  className: "st3",
  d: "M293.3,101.2c0,0,1.1,20,1.1,33.7c0,13.7-1.1,31.7-1.1,31.7"
}), /*#__PURE__*/React.createElement("path", {
  className: "st3",
  d: "M265.6,101.2c0,0-2.5,20-2.5,33.7s2.5,31.7,2.5,31.7"
}), /*#__PURE__*/React.createElement("path", {
  className: "st3",
  d: "M273.1,101.2c0,0-1.1,20-1.1,33.7c0,13.7,1.1,31.7,1.1,31.7"
})), /*#__PURE__*/React.createElement("rect", {
  x: 259,
  y: 95.8,
  className: "st6",
  width: 48.5,
  height: 5.4
}), /*#__PURE__*/React.createElement("rect", {
  x: 259,
  y: 166.6,
  className: "st6",
  width: 48.5,
  height: 5.4
}), /*#__PURE__*/React.createElement("rect", {
  x: 278.4,
  y: 101.2,
  className: "st7",
  width: 9.6,
  height: 65.4
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st7",
  d: "M311.7,129.9h-57c-0.2,2.5-0.4,4.9-0.4,7.3c0,0.6,0,1.1,0,1.6h57.8c0-0.5,0-1.1,0-1.6 C312.1,134.8,312,132.3,311.7,129.9z"
})), /*#__PURE__*/React.createElement("circle", {
  className: "st7",
  cx: 283.2,
  cy: 134.4,
  r: 1.9
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
  className: "st8",
  cx: 280.8,
  cy: 106.2,
  r: 1
}), /*#__PURE__*/React.createElement("circle", {
  className: "st8",
  cx: 280.8,
  cy: 111.9,
  r: 1
}), /*#__PURE__*/React.createElement("circle", {
  className: "st8",
  cx: 280.8,
  cy: 117.6,
  r: 1
}), /*#__PURE__*/React.createElement("circle", {
  className: "st8",
  cx: 280.8,
  cy: 123.3,
  r: 1
}), /*#__PURE__*/React.createElement("circle", {
  className: "st8",
  cx: 285.5,
  cy: 106.2,
  r: 1
}), /*#__PURE__*/React.createElement("circle", {
  className: "st8",
  cx: 285.5,
  cy: 111.9,
  r: 1
}), /*#__PURE__*/React.createElement("circle", {
  className: "st8",
  cx: 285.5,
  cy: 117.6,
  r: 1
}), /*#__PURE__*/React.createElement("circle", {
  className: "st8",
  cx: 285.5,
  cy: 123.3,
  r: 1
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
  className: "st8",
  cx: 280.8,
  cy: 143.8,
  r: 1
}), /*#__PURE__*/React.createElement("circle", {
  className: "st8",
  cx: 280.8,
  cy: 149.5,
  r: 1
}), /*#__PURE__*/React.createElement("circle", {
  className: "st8",
  cx: 280.8,
  cy: 155.1,
  r: 1
}), /*#__PURE__*/React.createElement("circle", {
  className: "st8",
  cx: 280.8,
  cy: 160.8,
  r: 1
}), /*#__PURE__*/React.createElement("circle", {
  className: "st8",
  cx: 285.5,
  cy: 143.8,
  r: 1
}), /*#__PURE__*/React.createElement("circle", {
  className: "st8",
  cx: 285.5,
  cy: 149.5,
  r: 1
}), /*#__PURE__*/React.createElement("circle", {
  className: "st8",
  cx: 285.5,
  cy: 155.1,
  r: 1
}), /*#__PURE__*/React.createElement("circle", {
  className: "st8",
  cx: 285.5,
  cy: 160.8,
  r: 1
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
  className: "st8",
  cx: 308.8,
  cy: 132,
  r: 1
}), /*#__PURE__*/React.createElement("circle", {
  className: "st8",
  cx: 303.1,
  cy: 132,
  r: 1
}), /*#__PURE__*/React.createElement("circle", {
  className: "st8",
  cx: 297.4,
  cy: 132,
  r: 1
}), /*#__PURE__*/React.createElement("circle", {
  className: "st8",
  cx: 291.8,
  cy: 132,
  r: 1
}), /*#__PURE__*/React.createElement("circle", {
  className: "st8",
  cx: 308.8,
  cy: 136.7,
  r: 1
}), /*#__PURE__*/React.createElement("circle", {
  className: "st8",
  cx: 303.1,
  cy: 136.7,
  r: 1
}), /*#__PURE__*/React.createElement("circle", {
  className: "st8",
  cx: 297.4,
  cy: 136.7,
  r: 1
}), /*#__PURE__*/React.createElement("circle", {
  className: "st8",
  cx: 291.8,
  cy: 136.7,
  r: 1
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
  className: "st8",
  cx: 275.3,
  cy: 132,
  r: 1
}), /*#__PURE__*/React.createElement("circle", {
  className: "st8",
  cx: 269.7,
  cy: 132,
  r: 1
}), /*#__PURE__*/React.createElement("circle", {
  className: "st8",
  cx: 264,
  cy: 132,
  r: 1
}), /*#__PURE__*/React.createElement("circle", {
  className: "st8",
  cx: 258.3,
  cy: 132,
  r: 1
}), /*#__PURE__*/React.createElement("circle", {
  className: "st8",
  cx: 275.3,
  cy: 136.7,
  r: 1
}), /*#__PURE__*/React.createElement("circle", {
  className: "st8",
  cx: 269.7,
  cy: 136.7,
  r: 1
}), /*#__PURE__*/React.createElement("circle", {
  className: "st8",
  cx: 264,
  cy: 136.7,
  r: 1
}), /*#__PURE__*/React.createElement("circle", {
  className: "st8",
  cx: 258.3,
  cy: 136.7,
  r: 1
})))), /*#__PURE__*/React.createElement("g", {
  id: "Q2D1"
}, /*#__PURE__*/React.createElement("path", {
  d: "M451.6,134.9c0-13.7-4.6-33.7-4.6-33.7v-0.1v-5.4h-48.5v5.4h0v0.2c-0.5,2.3-4.6,20.6-4.6,33.5c0,0.5,0,1,0,1.6 c0,0.3,0,0.5,0,0.8c0,0.6,0,1.1,0,1.6h0.1c0.7,12.1,4,25.7,4.5,27.5v0.2h0v5.4h48.5v-5.4c0,0,3.8-14.8,4.5-27.8h0.1 c0-0.5,0-1.1,0-1.6c0-0.3,0-0.5,0-0.8C451.5,135.9,451.6,135.4,451.6,134.9z"
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st5",
  d: "M398.9,101.2c0,0-4.6,20-4.6,33.7s4.6,31.7,4.6,31.7"
}), /*#__PURE__*/React.createElement("path", {
  className: "st5",
  d: "M447.4,101.2c0,0,4.6,20,4.6,33.7s-4.6,31.7-4.6,31.7"
}), /*#__PURE__*/React.createElement("path", {
  className: "st3",
  d: "M440.8,101.2c0,0,2.5,20,2.5,33.7s-2.5,31.7-2.5,31.7"
}), /*#__PURE__*/React.createElement("path", {
  className: "st3",
  d: "M433.2,101.2c0,0,1.1,20,1.1,33.7c0,13.7-1.1,31.7-1.1,31.7"
}), /*#__PURE__*/React.createElement("path", {
  className: "st3",
  d: "M405.5,101.2c0,0-2.5,20-2.5,33.7s2.5,31.7,2.5,31.7"
}), /*#__PURE__*/React.createElement("path", {
  className: "st3",
  d: "M413,101.2c0,0-1.1,20-1.1,33.7c0,13.7,1.1,31.7,1.1,31.7"
})), /*#__PURE__*/React.createElement("rect", {
  x: 418.3,
  y: 101.2,
  className: "st7",
  width: 9.6,
  height: 65.4
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st7",
  d: "M451.6,129.9h-57c-0.2,2.5-0.4,4.9-0.4,7.3c0,0.6,0,1.1,0,1.6H452c0-0.5,0-1.1,0-1.6 C452,134.8,451.9,132.3,451.6,129.9z"
})), /*#__PURE__*/React.createElement("circle", {
  className: "st7",
  cx: 423.1,
  cy: 134.4,
  r: 1.9
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
  className: "st8",
  cx: 420.7,
  cy: 106.2,
  r: 1
}), /*#__PURE__*/React.createElement("circle", {
  className: "st8",
  cx: 420.7,
  cy: 111.9,
  r: 1
}), /*#__PURE__*/React.createElement("circle", {
  className: "st8",
  cx: 420.7,
  cy: 117.6,
  r: 1
}), /*#__PURE__*/React.createElement("circle", {
  className: "st8",
  cx: 420.7,
  cy: 123.3,
  r: 1
}), /*#__PURE__*/React.createElement("circle", {
  className: "st8",
  cx: 425.4,
  cy: 106.2,
  r: 1
}), /*#__PURE__*/React.createElement("circle", {
  className: "st8",
  cx: 425.4,
  cy: 111.9,
  r: 1
}), /*#__PURE__*/React.createElement("circle", {
  className: "st8",
  cx: 425.4,
  cy: 117.6,
  r: 1
}), /*#__PURE__*/React.createElement("circle", {
  className: "st8",
  cx: 425.4,
  cy: 123.3,
  r: 1
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
  className: "st8",
  cx: 420.7,
  cy: 143.8,
  r: 1
}), /*#__PURE__*/React.createElement("circle", {
  className: "st8",
  cx: 420.7,
  cy: 149.5,
  r: 1
}), /*#__PURE__*/React.createElement("circle", {
  className: "st8",
  cx: 420.7,
  cy: 155.1,
  r: 1
}), /*#__PURE__*/React.createElement("circle", {
  className: "st8",
  cx: 420.7,
  cy: 160.8,
  r: 1
}), /*#__PURE__*/React.createElement("circle", {
  className: "st8",
  cx: 425.4,
  cy: 143.8,
  r: 1
}), /*#__PURE__*/React.createElement("circle", {
  className: "st8",
  cx: 425.4,
  cy: 149.5,
  r: 1
}), /*#__PURE__*/React.createElement("circle", {
  className: "st8",
  cx: 425.4,
  cy: 155.1,
  r: 1
}), /*#__PURE__*/React.createElement("circle", {
  className: "st8",
  cx: 425.4,
  cy: 160.8,
  r: 1
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
  className: "st8",
  cx: 448.7,
  cy: 132,
  r: 1
}), /*#__PURE__*/React.createElement("circle", {
  className: "st8",
  cx: 443,
  cy: 132,
  r: 1
}), /*#__PURE__*/React.createElement("circle", {
  className: "st8",
  cx: 437.3,
  cy: 132,
  r: 1
}), /*#__PURE__*/React.createElement("circle", {
  className: "st8",
  cx: 431.7,
  cy: 132,
  r: 1
}), /*#__PURE__*/React.createElement("circle", {
  className: "st8",
  cx: 448.7,
  cy: 136.7,
  r: 1
}), /*#__PURE__*/React.createElement("circle", {
  className: "st8",
  cx: 443,
  cy: 136.7,
  r: 1
}), /*#__PURE__*/React.createElement("circle", {
  className: "st8",
  cx: 437.3,
  cy: 136.7,
  r: 1
}), /*#__PURE__*/React.createElement("circle", {
  className: "st8",
  cx: 431.7,
  cy: 136.7,
  r: 1
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
  className: "st8",
  cx: 415.2,
  cy: 132,
  r: 1
}), /*#__PURE__*/React.createElement("circle", {
  className: "st8",
  cx: 409.6,
  cy: 132,
  r: 1
}), /*#__PURE__*/React.createElement("circle", {
  className: "st8",
  cx: 403.9,
  cy: 132,
  r: 1
}), /*#__PURE__*/React.createElement("circle", {
  className: "st8",
  cx: 398.2,
  cy: 132,
  r: 1
}), /*#__PURE__*/React.createElement("circle", {
  className: "st8",
  cx: 415.2,
  cy: 136.7,
  r: 1
}), /*#__PURE__*/React.createElement("circle", {
  className: "st8",
  cx: 409.6,
  cy: 136.7,
  r: 1
}), /*#__PURE__*/React.createElement("circle", {
  className: "st8",
  cx: 403.9,
  cy: 136.7,
  r: 1
}), /*#__PURE__*/React.createElement("circle", {
  className: "st8",
  cx: 398.2,
  cy: 136.7,
  r: 1
})), /*#__PURE__*/React.createElement("rect", {
  x: 398.9,
  y: 95.8,
  className: "st6",
  width: 48.5,
  height: 5.4
}), /*#__PURE__*/React.createElement("rect", {
  x: 398.9,
  y: 166.6,
  className: "st6",
  width: 48.5,
  height: 5.4
}))));

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "Q2heal2"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st9",
  d: "M295.6,132l9.8,1c1.6,0.2,3.4,4.1,2.8,8.5l0,0c-0.6,4.4-3.4,7.6-4.9,7.4l-9.9-1"
}), /*#__PURE__*/React.createElement("path", {
  className: "st9",
  d: "M265.6,137.6l22.8,21.7c1.1,1,2.8,0.4,3.1-1.1l5.1-36.3c0.2-1.5-1.3-2.5-2.6-1.9l-28,14.6 C265,135.2,264.7,136.7,265.6,137.6z"
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st9",
  d: "M276.1,140.6l-2.5-2.4c-0.4-0.4-1.2-0.2-1.3,0.4l-0.6,4c-0.1,0.6,0.6,1.1,1.1,0.8l3.1-1.6 C276.3,141.6,276.4,141,276.1,140.6z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st9",
  d: "M277.1,133.4l-2.5-2.4c-0.4-0.4-1.2-0.2-1.3,0.4l-0.6,4c-0.1,0.6,0.6,1.1,1.1,0.8l3.1-1.6 C277.4,134.4,277.4,133.8,277.1,133.4z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st9",
  d: "M282.4,146.7l-2.5-2.4c-0.4-0.4-1.2-0.2-1.3,0.4l-0.6,4c-0.1,0.6,0.6,1.1,1.1,0.8l3.1-1.6 C282.7,147.7,282.8,147,282.4,146.7z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st9",
  d: "M284.8,129.4l-2.5-2.4c-0.4-0.4-1.2-0.2-1.3,0.4l-0.6,4c-0.1,0.6,0.6,1.1,1.1,0.8l3.1-1.6 C285.1,130.3,285.2,129.7,284.8,129.4z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st9",
  d: "M283.6,138l-2.5-2.4c-0.4-0.4-1.2-0.2-1.3,0.4l-0.6,4c-0.1,0.6,0.6,1.1,1.1,0.8l3.1-1.6 C283.9,139,284,138.4,283.6,138z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st9",
  d: "M291.3,151.6l-4.3-4.1c-0.4-0.4-1.2-0.2-1.3,0.4l-1,6.9c-0.1,0.6,0.6,1.1,1.1,0.8l5.3-2.8 C291.6,152.6,291.7,151.9,291.3,151.6z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st9",
  d: "M294.7,127.1l-4.3-4.1c-0.4-0.4-1.2-0.2-1.3,0.4l-1,6.9c-0.1,0.6,0.6,1.1,1.1,0.8l5.3-2.8 C295,128.1,295.1,127.5,294.7,127.1z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st9",
  d: "M293,139.3l-4.3-4.1c-0.4-0.4-1.2-0.2-1.3,0.4l-1,6.9c-0.1,0.6,0.6,1.1,1.1,0.8l5.3-2.8 C293.3,140.3,293.4,139.7,293,139.3z"
})))));

var _ref5 = /*#__PURE__*/React.createElement("g", {
  id: "Q2man"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M318.6,151.3c0,0-1.4,9.5,6.8,13.2c13.8,6.3,14.9-2.7,14.9-2.7"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M382.7,151.5c0,0,2.2,9.2-6,13c-13.8,6.3-14.9-2.7-14.9-2.7"
}), /*#__PURE__*/React.createElement("path", {
  className: "st11",
  d: "M419.7,90.1C414,93,397.2,102,397.2,102l-13.4-14.1c-0.6-1.7-1.5-5-4.3-5.3c-0.6-6.6-1.1-12.6-1.6-17.2 c-2.1-21.9-4.2-46.5-27.2-46.5s-25.6,25.7-27.5,47.9c-0.4,4.3-0.8,9.8-1.3,15.9l0,0c-3.1,0-4.1,3.6-4.7,5.4l-17.7,52 c-0.6,1.8,0.1,3.8,1.6,4.5c1.5,0.7,3.1-0.1,3.7-1.9l15.7-42.7c-1.5,19.3-2.8,39-2.8,47.7c0,20.1,66,20.1,66,0 c0-9.6-1.2-28.5-2.7-46.8c0,0,7.4,7.1,13.6,11.8c2.9,2.2,23.8-13.2,31.7-18.3C430.3,91.6,424.8,87.6,419.7,90.1z"
}), /*#__PURE__*/React.createElement("line", {
  className: "st12",
  x1: 325.4,
  y1: 193.3,
  x2: 328.6,
  y2: 165.8
}), /*#__PURE__*/React.createElement("path", {
  className: "st13",
  d: "M330.7,199.5l-16.5-0.2c0,0,6.9-6.4,13-5.4S330.7,199.5,330.7,199.5z"
}), /*#__PURE__*/React.createElement("line", {
  className: "st12",
  x1: 376.7,
  y1: 193.3,
  x2: 373.6,
  y2: 165.8
}), /*#__PURE__*/React.createElement("path", {
  className: "st13",
  d: "M371.5,199.2l16.5,0.5c0,0-6.7-6.7-12.9-6C369,194.4,371.5,199.2,371.5,199.2z"
}), /*#__PURE__*/React.createElement("circle", {
  className: "st14",
  cx: 344.8,
  cy: 56.9,
  r: 1.7
}), /*#__PURE__*/React.createElement("circle", {
  className: "st14",
  cx: 357.2,
  cy: 56.9,
  r: 1.7
}), /*#__PURE__*/React.createElement("path", {
  className: "st15",
  d: "M336.4,67.4c1.9,4.2,7.4-1.4,15.8-1.4H352c8.4,0,13.9,5.7,15.8,1.4"
})), /*#__PURE__*/React.createElement("polygon", {
  points: "322.1,66 321.6,71.9 323.8,73 324.4,67.2  "
}), /*#__PURE__*/React.createElement("polygon", {
  points: "379,67.1 379.6,73 377.4,74.2 376.8,68.4  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st16",
  d: "M337.4,149.1l-1.1,8.4c-0.3,2.7,1.8,6.9,4.5,6.9c0,0,4.1,0.9,9.2,0.9c2.5,0,9.8-0.9,9.8-0.9 c2.6,0,4.7-4.1,4.6-6.7l-0.6-8.1"
}), /*#__PURE__*/React.createElement("path", {
  className: "st17",
  d: "M337.5,157.6c0,0,7.1,1.6,12.8,1.4s13.9-2,13.9-2"
}), /*#__PURE__*/React.createElement("path", {
  className: "st17",
  d: "M337.5,155.1c0,0,7.1,1.6,12.8,1.4s13.9-2,13.9-2"
}), /*#__PURE__*/React.createElement("path", {
  className: "st18",
  d: "M293.5,28.2c0-7.3,25.5-18.9,57-18.9s57,11.6,57,18.9s-25.5,13.1-57,13.1S293.5,35.4,293.5,28.2z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st18",
  d: "M343.6,119.8c-21.4,0-24.1-6.2-24.1-6.2L309,143.5c0,0,17.4,11.7,25.1,9.1 C341.3,150.1,343.6,119.8,343.6,119.8z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st19",
  d: "M310,140.5c5.8,3.2,16.7,8.1,21.5,6.4c5-1.7,7.6-16.6,8.8-25.8"
}), /*#__PURE__*/React.createElement("path", {
  className: "st18",
  d: "M357.4,119.8c21.4,0,24.1-6.2,24.1-6.2l10.5,29.9c0,0-17.4,11.7-25.1,9.1 C359.7,150.1,357.4,119.8,357.4,119.8z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st18",
  d: "M362.2,125.8c-6.4,20.4-45.9,12.4-45.9,12.4l3.2-17H358L362.2,125.8z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st19",
  d: "M358.5,122.2c-5.9,16.4-31.7,12.6-41.4,11.2"
}), /*#__PURE__*/React.createElement("path", {
  className: "st18",
  d: "M347.2,115.2c-13.1-0.4-20.9-3.1-24.7-4.8c-1.6-0.7-3.4,0-4,1.6l-2,5.3c-0.6,1.6,0.4,3.3,2.1,3.7l27,6.4 c1.7,0.4,3.4-0.7,3.6-2.4l0.9-6.6C350.2,116.7,348.9,115.3,347.2,115.2z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st18",
  d: "M354.3,115.2c13-0.4,20.6-3.1,24.3-4.8c1.5-0.7,3.4,0,4,1.6l2,5.3c0.6,1.6-0.4,3.3-2,3.7l-26.7,6.4 c-1.7,0.4-3.3-0.7-3.6-2.4l-0.9-6.6C351.3,116.7,352.6,115.3,354.3,115.2z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st20",
  d: "M319.7,110.5l0.7-9.8c0.1-0.9,0.7-1.6,1.6-1.7c1.7-0.3,3.1-1.6,3.5-6c0.8-8.8-3.6-10.4-3.6-10.4l0.8-9.9"
}), /*#__PURE__*/React.createElement("path", {
  className: "st20",
  d: "M369.6,82.7c0,0-0.1,4.8,2.9,10.8c2.2,4.4,5.8,5.2,7.4,5.3c0.6,0,1,0.5,1,1.1l0.8,10.9"
}), /*#__PURE__*/React.createElement("path", {
  className: "st21",
  d: "M361.1,128.4c0,0,3.6,3.8,13.6,4.4s13.2-0.9,13.2-0.9"
}), /*#__PURE__*/React.createElement("path", {
  className: "st21",
  d: "M359.2,132.5c0,0,5.3,4.6,15.3,5.2s15.7-1.3,15.7-1.3"
}), /*#__PURE__*/React.createElement("path", {
  className: "st18",
  d: "M341.5,84.9c-6-10.9-34.2-17.2-34.2-17.2c0.4-12.6,17.4-14.9,17.4-14.9"
}), /*#__PURE__*/React.createElement("path", {
  className: "st18",
  d: "M332.8,113.6c3.4-6.5,2.7-17.5,1.1-24.7c-0.4-2,1.2-4,3.2-3.9c8.1,0.1,25.4,0.1,32.5-2.3 c6.9-12.7,30.1-15.3,30.1-15.3c-0.9-10.1-23.4-13.9-23.4-13.9c0.4,3.2,1.1,10.6,1.3,13.5"
}), /*#__PURE__*/React.createElement("path", {
  className: "st22",
  d: "M369.6,82.7c0,0,5.4-14,10.7-17.4c1.5-1-2.6-2.4-2.6-2.4"
}), /*#__PURE__*/React.createElement("path", {
  className: "st22",
  d: "M341.5,84.9c0,0-7.8-13.8-20.8-19.6c-1.7-0.7,2.6-2.4,2.6-2.4"
}), /*#__PURE__*/React.createElement("path", {
  className: "st11",
  d: "M376.4,51c0,0,1.3,11.4,1.6,14.1"
}), /*#__PURE__*/React.createElement("path", {
  className: "st11",
  d: "M324.9,51c0,0-1.3,11.4-1.6,14.1"
}), /*#__PURE__*/React.createElement("path", {
  className: "st19",
  d: "M379.5,13.2c-5.4,1.7-16.3,2.9-29,2.9c-12.5,0-23.4-1.2-28.8-2.9"
}), /*#__PURE__*/React.createElement("path", {
  className: "st19",
  d: "M393.7,17.3c-9.1,2.7-25,4.5-43.2,4.5c-18.1,0-34.1-1.8-43.2-4.5"
}), /*#__PURE__*/React.createElement("path", {
  className: "st20",
  d: "M404.3,22.7c-12.1,4.5-31.7,7.5-53.8,7.5c-22.2,0-41.9-3-53.9-7.5"
}), /*#__PURE__*/React.createElement("polyline", {
  className: "st19",
  points: "298.1,23.2 298.1,33.4 312.1,26.8 318.5,39.1 332.8,29.5 340.3,41.3 350.5,30.1 359.4,41.1  368.1,29.5 379.5,39.5 385.8,27.4 398.3,35.3 399.7,25.3 407.5,28.2  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st19",
  d: "M340.5,85c0,0,1.3,8.2,1.4,13.2c0.1,5-0.4,16.6-0.4,16.6"
}), /*#__PURE__*/React.createElement("path", {
  className: "st19",
  d: "M348,85c0,0,1.3,8.2,1.4,13.2c0.1,5-0.4,16.6-0.4,16.6"
}), /*#__PURE__*/React.createElement("path", {
  className: "st19",
  d: "M355.6,85c0,0,1.3,8.2,1.4,13.2c0.1,5-0.4,16.6-0.4,16.6"
}), /*#__PURE__*/React.createElement("path", {
  className: "st19",
  d: "M363.2,85c0,0,1.3,8.2,1.4,13.2s-0.4,16.6-0.4,16.6"
}), /*#__PURE__*/React.createElement("path", {
  className: "st19",
  d: "M371.8,93c0.2,1.8,0.3,3.7,0.4,5.2c0.1,3.7-0.2,11-0.3,14.6"
}), /*#__PURE__*/React.createElement("path", {
  className: "st19",
  d: "M355.6,115.8c0,0,0,6.4,0.7,6.9c1.5,1,19.9-4,28-6.1"
}), /*#__PURE__*/React.createElement("path", {
  className: "st19",
  d: "M346.4,115.2c0,0,0,6.4-0.7,6.9c-1.5,1-19.9-4-28-6.1"
}), /*#__PURE__*/React.createElement("path", {
  className: "st21",
  d: "M371.2,149.3L371.2,149.3c-1.3,0.4-2.7-0.4-3.1-1.8l-1.1-3.9c-0.4-1.3,0.4-2.7,1.8-3.1l0,0 c1.3-0.4,2.7,0.4,3.1,1.8l1.1,3.9C373.3,147.6,372.5,149,371.2,149.3z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st21",
  d: "M368.1,136.7c0,0-1.3,2.3,0.7,3.8"
}), /*#__PURE__*/React.createElement("path", {
  className: "st21",
  d: "M367,143.9c0,0,1,0.8,2.7,0.2s2.2-1.6,2.2-1.6"
}), /*#__PURE__*/React.createElement("path", {
  className: "st21",
  d: "M367.7,146.2c0,0,1,0.8,2.7,0.2s2.2-1.6,2.2-1.6"
}), /*#__PURE__*/React.createElement("path", {
  className: "st19",
  d: "M328.9,75c0,0,0.4,9.4,0.4,15.1s-2.6,21.9-2.6,21.9"
}));

var _ref6 = /*#__PURE__*/React.createElement("g", {
  id: "Q2heal1"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st4",
  d: "M447.4,51.5l-7.7-0.6c0,0-0.5,6.4-0.6,7.7c-0.1,0.7,1,1.8,1.9,2.8c1,1,1.5,2.3,1.4,3.7l-1.6,20 c-0.2,2.6-2.4,4.5-5,4.2l-19-1.6c-2.6-0.2-4.5-2.4-4.2-5l1.6-20c0.1-1.4,0.8-2.7,2-3.4c1.1-0.7,2.3-1.7,2.4-2.4 c0.1-1.3,0.6-7.7,0.6-7.7l-7.7-0.6"
}), /*#__PURE__*/React.createElement("path", {
  className: "st4",
  d: "M434.4,85.2l-15.6-1.3c-1-0.1-1.8-1-1.7-2.1l1-12.1l19.4,1.6l-1,12.1C436.4,84.5,435.4,85.3,434.4,85.2z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st4",
  d: "M427.9,53c-0.6,1.2-0.2,3.1,1.1,3.3c3.1,0.5,4.5-1,5.4-2.5c1.2-2-1-4.2-2.9-5.1c-2.4-1.2-5.3-0.2-6.5,2.2 c-1.5,3-0.2,6.5,2.7,8.1c4.1,2.4,0.7,9.1,0.7,9.1"
}))));

var SvgQ2Svg = function SvgQ2Svg(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "Q2svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 714.5 202",
    style: {
      enableBackground: "new 0 0 714.5 202"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgQ2Svg, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Q2svg.0440a5b1.svg";
export { ForwardRef as ReactComponent };